<div class="integrations-page">
    <h1 class="page-title">{{ 'aumico_integrations_page_title' | i18next }}</h1>
    <aumico-integrations-overview></aumico-integrations-overview>
    <aumico-partner-connect-section [loginHint]="loginHint"></aumico-partner-connect-section>
    <!-- Self-serve partner credentials (REV-21638) are deferred: the launch partner connects
         via Guided Connect, so the section is hidden, not removed — component, store and
         translations stay shipped. Re-enable by re-adding:
         <aumico-outbound-api-section></aumico-outbound-api-section> -->
</div>
